import { cn } from 'common/utils'

export const wrapperClasses =
  'mx-auto justify-center md:max-w-screen-sm lg:max-w-screen-md xl:max-w-screen-xl'

export const stripeClasses =
  '-mt-4 -mx-4 h-20 border-b border-t border-gray-500'

const BoldHeaderStripe = ({
  theme,
  header,
  children,
  stripeContent,
  stripeStyle,
}) => (
  <>
    {stripeContent ? (
      stripeContent
    ) : (
      <div
        style={stripeStyle}
        className={cn(
          stripeClasses,
          theme
            ? theme.moodBgBold
            : 'bg-gradient-to-t from-blue-400 to-blue-800',
        )}
      />
    )}
    <div className={cn('flex -mt-10', wrapperClasses)}>{header}</div>
    <div className={cn(wrapperClasses, 'mb-24')}>{children}</div>
  </>
)

export default BoldHeaderStripe
